import './Hero.css'

const TECH_TAGS = ['React 19', 'TypeScript', 'Node.js', 'Vite', 'TanStack', 'Tailwind', 'PostgreSQL', 'Docker', 'Java', 'Python', 'Linux', 'Oracle', 'HTML', 'Javascript', 'CSS']

export function Hero() {
  // const scrollToContact = (e: React.MouseEvent) => {
  //   e.preventDefault()
  //   document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })
  // }

  return (
    <section className="hero">
      <div className="hero__glow" aria-hidden="true" />

      <div className="hero__inner container">
        <div className="hero__content">

          <span className="label hero__label animate-fade-up" style={{ animationDelay: '0ms' }}>
            Clearwater, FL · Remote-first · Est. 2026
          </span>

          <h1 className="hero__headline animate-fade-up" style={{ animationDelay: '80ms' }}>
            Building Tomorrow's<br />
            <span className="gradient-text">Web, Today.</span>
          </h1>

          <p className="hero__body animate-fade-up" style={{ animationDelay: '160ms' }}>
            We craft high-performance web experiences using modern stacks and
            adaptive architecture — so your product can scale without limits.
          </p>

          <div className="hero__actions animate-fade-up" style={{ animationDelay: '240ms' }}>
            {/* <a href="#contact" className="btn btn--primary hero__btn-primary" onClick={scrollToContact}>
              Start a Project
              <ArrowIcon />
            </a> */}
            <a href="#about" className="btn btn--outline" onClick={(e) => { e.preventDefault(); document.getElementById('about')?.scrollIntoView({ behavior: 'smooth' }) }}>
              Learn More
            </a>
          </div>

          <div className="hero__tags animate-fade-up" style={{ animationDelay: '320ms' }}>
            {TECH_TAGS.map(tag => (
              <span key={tag} className="hero__tag">{tag}</span>
            ))}
          </div>
        </div>

        <div className="hero__visual animate-fade-in" style={{ animationDelay: '200ms' }} aria-hidden="true">
          <HeroVisual />
        </div>
      </div>

      <div className="hero__scroll animate-fade-in" style={{ animationDelay: '800ms' }} aria-hidden="true">
        <div className="hero__scroll-line" />
      </div>
    </section>
  )
}

// function ArrowIcon() {
//   return (
//     <svg width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true">
//       <path d="M1 7H13M7 1L13 7L7 13" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
//     </svg>
//   )
// }

function HeroVisual() {
  return (
    <div className="hero-visual">
      <div className="hero-visual__orbit hero-visual__orbit--1">
        <div className="hero-visual__dot" />
      </div>
      <div className="hero-visual__orbit hero-visual__orbit--2">
        <div className="hero-visual__dot" />
      </div>
      <div className="hero-visual__orbit hero-visual__orbit--3">
        <div className="hero-visual__dot hero-visual__dot--orange" />
      </div>

      <div className="hero-visual__core">
        <svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M4 16L12 8V12H20V8L28 16L20 24V20H12V24L4 16Z" fill="#00d4ff"/>
        </svg>
      </div>
    </div>
  )
}

// import type React from 'react'
